<template>
    <div class="justify-content-center text-center otpverification">
        <div class="mainTitle text-center mt-4 mb-3">
            <h3 class="mb-2"> {{$t('otpVerification')}}</h3> 
            <!-- <small class="d-block mb-4"> {{$t('otpVerificationText')}}</small> -->
            <p class="mb-3"> {{$t('otpVerificationText1')}}</p> 
        </div> 
        <div class="CustomBlockWidth inMiddle-area whitebox p-4 mb-4"> 
            <img class="otp mb-3" src="../../../../../static/fxView/images/otp.svg" alt="one time password">
            
            <div class="form-group field-wrapper" > 
                <input placeholder=" " class="float-field form-control" v-model="otp" name="OTP" type="text" v-validate="{ required: true, max: 6,numeric : true }" :class="{ 'is-invalid': submitted && errors.has('OTP') }" ref="otpInput">
                <label for="username" class="float-label"> {{$t('verifyCode')}}</label>   
                <p class="error text-left" v-for="error in errors.collect('OTP')">{{ error }}</p>   
            </div>   
            <div class="clearfix"></div>
            <div class="validatebtn d-flex align-items-center justify-content-center mb-3">
                
                <button class="prism_btn btn_sm " v-on:click="submit()"> {{$t('validate')}} </button>  
            </div>
            <div class="text-center">
                <a href="#" class="underline" v-on:click="resendOtp()"> {{$t('resendOtpTicket')}}</a>
            </div>
        </div>
        <div class="text-center" v-if="ticketRequestFrom == 'profileOtp'">
			<a class="mr-3 underline" href="#" @click="$parent.trans_id = ''">back</a>
        </div>
		<div class="text-center" v-else>
            <a class="mr-3 underline" href="#" @click="$parent.backTick()">{{$t('backToTicket')}}</a>
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'  
    export default {
        mixins:[fxViewMixins],
        data(){
            return {
                'otp' : '',
                'data_msz' :'',
                submitted : false
            }
        },
        props:['transaction_id','module','data','ticketRequestFrom','accountId','title_parent'],
        methods:{
			resendOtp(){
				let input_json={
					'globalParams' :{
						'trans_id' : this.transaction_id.toString()
					},
					'localParams' :{ "parameter" : this }
				}
				this._runTicketResendOtp(input_json)
			},
            submit(){
                const _that = this
                _that.submitted = true;
                _that.data_msz = _that.data
                _that.$validator.validate().then(valid => {
                    if (valid){
                        let input_json={
                            'globalParams' :{
                                'otp' :  _that.otp.toString(), 
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that , 'module' : _that.module , 'data' : _that.data_msz ,'ticketRequestFrom' : _that.ticketRequestFrom , 'accountId' : _that.accountId ,'title':_that.title_parent}
                        }
                        _that._runTicketCheckOtp(input_json)
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/services/otp_verification.vue